<template lang="html">
  <div class="modal-wrapper choose-registration-modal">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div class="modal-title">
      {{ $t("main.userType") }}
      <img src="@/assets/newImges/register-icon.png" alt="regiser" />
    </div>
    <p class="left">{{ $t("register.noAccount") }}</p>
    <div class="big-btn-wrapper">
      <router-link
        :to="{
          name: 'Register',
          params: { lang: $i18n.locale },
          query: { type: 'business' }
        }"
        @click.native="closeModal()"
        class="big-btn yellow"
      >
        <div class="big-btn-title">
          {{ $t("main.registrationBusiness") }}
        </div>
        <div class="big-btn-text">
          {{ $t("main.registrationBusinessText") }}
        </div>
      </router-link>
      <router-link
        :to="{ name: 'Register', params: { lang: $i18n.locale } }"
        @click.native="closeModal()"
        class="big-btn red"
      >
        <div class="big-btn-title">
          {{ $t("main.registrationStandard") }}
        </div>
        <div class="big-btn-text">
          {{ $t("main.registrationStandardText") }}
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import eventBus from "@/shared/eventBus.js";
import { query } from "vue-gtag";
export default {
  name: "chooseRegistrationModal",
  methods: {
    openModal(modal) {
      eventBus.$emit("openModal", { component: modal, outsideClose: false });
    },
    closeModal() {
      eventBus.$emit("closeModal");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/modalStyles.scss";

.modal-overlay .modal-wrapper.choose-registration-modal {
  width: auto;
  padding: 25px;
  padding-bottom: 59px;
  padding-top: 25px;
  .left {
    text-align: left;
    padding-left: 25px;
  }

  .modal-title {
    padding-left: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 41px;
    img {
      transform: translateY(-4px);
    }
  }

  .big-btn-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 20px;
    margin: 0 20px;

    .big-btn {
      padding: 20px 25px;
      text-align: left;
      border-radius: 20px;
      cursor: pointer;
      transition-duration: 0.2s;
      max-width: 400px;
      border: 2px solid $gray-blue-700;
      // box-shadow: 0px 0px 0px rgba(112, 116, 223, 0.49);
      width: 100%;
      height: auto;
      min-height: 130px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-decoration: none;
      .big-btn-title {
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 29px;
        letter-spacing: 0.06em;
        margin-bottom: 10px;
        text-transform: uppercase;
        color: $blue-1000;
        // color: #ffffff;
      }
      .big-btn-text {
        color: $blue-400;
        font-weight: 400;
        font-size: 16px;
        line-height: 30px;
        // letter-spacing: 0.02em;
      }
      .big-btn-continue {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: auto;
        text-transform: uppercase;
      }
      .big-btn-continue span {
        margin-right: 10px;
        font-style: normal;
        font-weight: 800;
        font-size: 10px;
        line-height: 16px;
        letter-spacing: 0.06em;
      }
    }
    .big-btn:hover {
      transform: scale(1.03);
    }
  }
}
@media only screen and (max-width: 768px) {
  .modal-overlay .modal-wrapper.choose-registration-modal .big-btn-wrapper {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .modal-overlay
    .modal-wrapper.choose-registration-modal
    .big-btn-wrapper
    .big-btn.red {
    margin-right: 0px;
    margin-bottom: 35px;
  }
}
</style>
